/**
 * Lazy-loaded components for better performance
 */
import { lazy } from 'react';

// Heavy organisms - lazy load to reduce initial bundle
export const LazyInvoiceList = lazy(() => 
  import('@organisms/invoice/InvoiceList').then(module => ({ 
    default: module.InvoiceList 
  }))
);

export const LazySupplierList = lazy(() => 
  import('@organisms/supplier/SupplierList').then(module => ({ 
    default: module.SupplierList 
  }))
);

export const LazyAuditLog = lazy(() => 
  import('@organisms/shared/AuditLog').then(module => ({ 
    default: module.AuditLog 
  }))
);


// Pre-load components on user interaction
export const preloadInvoiceList = () => import('@organisms/invoice/InvoiceList');
export const preloadSupplierList = () => import('@organisms/supplier/SupplierList');
